module.exports = __webpack_public_path__ + "img/Carreras-SENA.5def51a3.jpg";